import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import StepNavigationComponent from '../../../components/shared_components/tool/StepNavigationComponent';
import PrimaryButton from '../../../components/shared_components/buttons/PrimaryButtonComponent';
import ChooseProductTable from '../../../components/tool/step3/ChooseProductTable';
import ShowProvidersComponent from '../../../components/overview/ShowProvidersComponent';
import LoaderComponent from '../../../components/shared_components/LoaderComponent';

@withRouter
@observer
class OverviewContainer extends React.Component {
  constructor(props) {
    super(props);

    this.navigateBack = this.navigateBack.bind(this);
  }

  componentWillMount() {
    const {
      sortLabelInterestsByTermInterestAvailable,
      sortLabelInterestsByTermInterest,
    } = this.props.ToolOverviewData;

    this.props.CalculationFormData.labelInterests = sortLabelInterestsByTermInterestAvailable(
      this.props.CalculationFormData.labelInterests);
    this.props.CalculationFormData.labelInterests = sortLabelInterestsByTermInterest(20,
      this.props.CalculationFormData.labelInterests);
  }

  navigateBack() {
    this.props.history.push('step-1');
  }

  render() {
    const {
      labelInterests,
    } = this.props.CalculationFormData;

    return (
      <div className="step3-container">
        <div>
          <StepNavigationComponent
            classNames="medium-42 columns float-right"
          />
        </div>

        <div className="columns medium-84 tool-header">

          <h1>Kies een aanbieder en product om uw maandlast te berekenen</h1>
          <p>Hypotheekrentetarieven worden in de meeste gevallen vergeleken op basis van de
             aanvangsrente bij het afsluiten van de hypotheek en niet over de te betalen
             hypotheekrente gedurend de looptijd van de hypotheek.</p>
          <p>Bij vergelijken op de aanvangsrente wordt er vaak geen rekening gehouden
             met het vervallen van de zogenaamde renteopslagen gedurende de looptijd van de hypotheek.</p>
          <br />
          <p>De looptijdrente geeft voor de consument een veel beter beeld van de totale kosten
             van een hypotheek gedurende de looptijd van een hypotheek.</p>
          <br />
          <p>Er is voor de hele looptijd/rentevasteperiode van de hypotheek gerekend
             met het rentepercentage van de gekozen rentevast periode.Na de rentevaste
             periode kan het rentepercentage in werkelijkheid anders zijn.</p>

        </div>

        <div className="columns center-block">
          <LoaderComponent
            show={labelInterests.length === 0}
          />
        </div>

        <ChooseProductTable
          show={labelInterests.length > 0}
          labelInterests={labelInterests}
        />

        <div className="full-row">
          <div className="medium-14 float-right columns overview-container__show-all-providers">
            <ShowProvidersComponent
              labelInterests={labelInterests}
              storeData={this.props.ToolOverviewData}
              show={labelInterests}
            />
          </div>
        </div>
        <div className="full-row">
          <div className="medium-14 columns float-left">
            <PrimaryButton
              text="Terug"
              onClickHandler={this.navigateBack}
              show
            />
          </div>
        </div>
      </div>
    );
  }
}

OverviewContainer.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  CalculationFormData: PropTypes.shape({
    labelInterests: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  ToolOverviewData: PropTypes.shape({
    setForm: PropTypes.func,
    form: PropTypes.shape({}),
    sortLabelInterestsByTermInterestAvailable: PropTypes.func,
    sortLabelInterestsByTermInterest: PropTypes.func,
  }),
};

OverviewContainer.defaultProps = {
  history: {
    push: () => {},
  },
  CalculationFormData: {
    labelInterests: [],
  },
  ToolOverviewData: {
    setForm: () => {},
    form: {},
  },
};

export default inject('ToolOverviewData', 'CalculationFormData')(OverviewContainer);
